import React from 'react';
import type { AssistantChat } from 'components/framework/models';
import SharePopover from './SharePopover';
import { ApplicationView } from '@aha-app/mvc';

interface ShareChatPopoverProps {
  chat: AssistantChat;
}

const ShareChatPopover: React.FC<ShareChatPopoverProps> = ({ chat }) => {
  const shareUrl = `/assistant/shared_chats/${chat.token}`;

  return <SharePopover shareUrl={shareUrl} name='chat' tokenOwner={chat} />;
};

export default ApplicationView(ShareChatPopover);
